import { Facts } from './facts'
import { RequestedEntityType, RequestType } from './requestDto'

export type Offers = {
	material: Offer
	materialWithTransport: Offer
	transport: Offer
}

export type Offer = {
	publicId: string
	offerLocation?: string
	offerLocationId?: string
	hasMaterialProfile?: boolean
	createPopMaterial: boolean
	offerCandidateRequestedEntityId?: string
	offerCandidateRequestedEntityType?: RequestedEntityType
	requestType: RequestType
	facts: Facts
	furtherDetailsComment: string
	optimizerPublicComment: string
	offerState?: OfferState
}

export type OfferDesignatedEntity = {
	id: string
	label: string
	type: RequestedEntityType
	hasMaterialProfile?: boolean
}

export function EmptyOffer(requestType: RequestType = RequestType.MATERIAL): Offer {
	return {
		publicId: '',
		offerLocation: '',
		createPopMaterial: false,
		requestType: requestType,
		facts: new Facts(),
		furtherDetailsComment: '',
		optimizerPublicComment: '',
		offerCandidateRequestedEntityId: '',
		offerCandidateRequestedEntityType: RequestedEntityType.POP
	}
}

export enum OfferState {
	ACCEPTED = 'ACCEPTED',
	DISCARDED = 'DISCARDED',
	DRAFT = 'DRAFT',
	READY = 'READY',
	REJECTED = 'REJECTED',
	REJECTED_MM = 'REJECTED_MM',
	SENT = 'SENT',
	WITHDRAWN = 'WITHDRAWN'
}

export enum OfferReactionButtons {
	POSITIVE = 'positive',
	NEUTRAL = 'neutral',
	NEGATIVE = 'negative'
}
